<template>
  <div class="content">
    <form>
      <production-form :datas="dataall"></production-form>
      <kontragent :datas="dataall"></kontragent>
      <firma></firma>
      <sklad :datas="dataall"></sklad>
      <paytype :datas="dataall"></paytype>
    </form>
    <b-modal id="modal-close" centered>
      <h4>
        {{$t('Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?')}}
      </h4>

      <template #modal-footer="{ ok, cancel, hide }">
        <button type="button" class="btn btn-success" style="margin-bottom: 16px;"
          @click="$root.$refs.production.Savedokument()">{{$t('Да')}}</button>
        <button type="button" class="btn btn-danger" @click='Home()'>{{$t('Нет')}}</button>
        <button type="button" class="btn btn-primary" @click="cancel()">{{$t('Отмена')}}</button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import ProductionForm from "./Form.vue"
import { Kontragent, Firma, Sklad, Paytype } from "@/pages";
export default {
  components: {
    ProductionForm,
    Kontragent,
    Firma,
    Sklad,
    Paytype
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  beforeMount() {
    // window.addEventListener("beforeunload", this.preventNav);
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved <2) {
      this.$store.state.saved = null;
      localStorage.removeItem("prostatka");
      next();
      this.$store.state.selected_index = null;
    } else {
      this.$bvModal.show("modal-close");
    }
  },
  data() {
    return {
      dataall: {
        sklad_id: parseInt(localStorage.getItem("sklad_id")),
        created_at: new Date().valueOf().toString().slice(0, 10),
        updated_at: new Date().valueOf().toString().slice(0, 10),
        rasxod_summa: 0,
        debit_summa: 0,
        comment: "",
        count_all: 0,
        pay_type_id:1,
        dollar_rate:1,
        production_doc_calc: 
        [
          {
            calculation_id : 0,
			      product_id : 0,
		  	    current_balance: 0,
			      count : 0,
			      debit_price : 0,
			      debit_summa : 0,
			      chakana_percent : 0,
			      optom_percent : 0,
			      chakana_price : 0,
			      optom_price : 0,
			      chakana_summa : 0,
			      optom_summa : 0,
            norma: 1,
            chakana_dollar_price:0,
            optom_dollar_price:0,
            rasxod_summa:0,
            seryo_summa:0,
            production_doc_product: []
          }
	      ]
      }
    };
  },
  created:function(){
    let self=this;
    axios
        .get("api/v1/dollar-exchange-rate/last")
        .then(function(response) {
            self.dataall.dollar_rate=response.data.rate;
            self.$store.state.saved=null;
        });
  },
  methods: {
    Home() {
        this.$store.state.saved = null;
        this.$bvModal.hide('modal-close');
        this.$router.push({ name: "Ишлаб чиқариш" });
      }
  },
};
</script>
